import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class CredentialsInterceptorService implements HttpInterceptor {
  private baseUrl = environment.apiBaseUrl;

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (request.url.startsWith(this.baseUrl) && !request.withCredentials) {
      return next.handle(request.clone({ withCredentials: true }));
    }
    return next.handle(request);
  }
}

